import { faCalendarCheck, faCalendarDays, faCalendarXmark } from "@fortawesome/free-solid-svg-icons"

export const statusAgendamentosUtils = () => {


    return [
        {
            id: 1,
            nome: 'Agendado',
            color: 'rgb(113 203 221)',
            colorLight: 'rgb(113 203 221 / 7%)',
            barcode: 'rgb(113 203 221)',
            iconFa: faCalendarDays,
            classEvent: "ev_agenda ev_agendado"

        }, {
            id: 2,
            nome: 'Em Andamento',
            color: '#ffc107',
            colorLight: 'rgba(255, 193, 7, 0.05)',
            iconFa: faCalendarDays,
            classEvent: "ev_agenda ev_andamento"
        }, {
            id: 3,
            nome: 'Finalizado',
            color: '#198754',
            colorLight: 'rgba(25, 135, 84, 0.05)',
            iconFa: faCalendarCheck,
            classEvent: "ev_agenda ev_finalizado"
        },
        {
            id: 4,
            nome: 'Desmarcado',
            color: '#dc3545',
            colorLight: 'rgba(220, 53, 69, 0.05)',
            iconFa: faCalendarXmark,
             classEvent: "ev_agenda ev_finalizado"
        },
    ]
}